import { action } from "typesafe-actions";
import {
  CreateHallPayload,
  GetHallRoomPayload,
  GetHallRoomsPayload,
  Hall,
  UpdateHallPayload,
} from "../../interfaces";
import { HallActionTypes } from "./types";

export const getHalls = (payload: string | number) => {
  return action(HallActionTypes.FETCH_HALLS_REQUEST, payload);
};

export const getHallsSuccess = (halls: Hall[]) => {
  return action(HallActionTypes.FETCH_HALLS_SUCCESS, halls);
};

export const getHallsFailure = (error: any) => {
  return action(HallActionTypes.FETCH_HALLS_ERROR, error);
};

export const getHall = (payload: string) => {
  return action(HallActionTypes.FETCH_HALL_REQUEST, payload);
};

export const getHallSuccess = (hall: Hall) => {
  return action(HallActionTypes.FETCH_HALL_SUCCESS, hall);
};

export const getHallFailure = (error: any) => {
  return action(HallActionTypes.FETCH_HALL_ERROR, error);
};

export const createHall = (payload: CreateHallPayload) => {
  return action(HallActionTypes.CREATE_HALL_REQUEST, payload);
};

export const createHallSuccess = (hall: Hall) => {
  return action(HallActionTypes.CREATE_HALL_SUCCESS, hall);
};

export const createHallFailure = (error: any) => {
  return action(HallActionTypes.CREATE_HALL_ERROR, error);
};

export const updateHall = (payload: UpdateHallPayload) => {
  return action(HallActionTypes.UPDATE_HALL_REQUEST, payload);
};

export const updateHallSuccess = (hall: Hall) => {
  return action(HallActionTypes.UPDATE_HALL_SUCCESS, hall);
};

export const updateHallFailure = (error: any) => {
  return action(HallActionTypes.UPDATE_HALL_ERROR, error);
};

export const deleteHall = (payload: string | number) => {
  return action(HallActionTypes.DELETE_HALL_REQUEST, payload);
};

export const deleteHallSuccess = (hall: CreateHallPayload) => {
  return action(HallActionTypes.DELETE_HALL_SUCCESS, hall);
};

export const deleteHallFailure = (error: any) => {
  return action(HallActionTypes.DELETE_HALL_ERROR, error);
};

export const getHallRooms = (payload: GetHallRoomsPayload) => {
  return action(HallActionTypes.FETCH_HALL_ROOMS_REQUEST, payload);
};

export const getHallRoomsSuccess = (halls: Hall[]) => {
  return action(HallActionTypes.FETCH_HALL_ROOMS_SUCCESS, halls);
};

export const getHallRoomsFailure = (error: any) => {
  return action(HallActionTypes.FETCH_HALL_ROOMS_ERROR, error);
};

export const clearHallState = () => {
  return action(HallActionTypes.CLEAR_HALL_STATE);
};
